import React from 'react'
import StyledMdText from '../../../common/components/styledMdText/StyledMdText'
import StyledSmText from '../../../common/components/styledSmText/StyledSmText'
import StyledH3Heading from '../../../common/components/styledH3Heading/StyledH3Heading'
import HubCard from '../../../components/hubCard/HubCard'
import Button from '../../../components/button/Button'

const hubData = [
    {
        imgUrl: "/assets/images/hub-img1.webp",
        heading: "Crowdfunding Marketplace",
        desc: "Operate a next-gen decentralized crowdfunding platform, facilitating project funding with low fees and instant transaction confirmation.",
    },
    {
        imgUrl: "/assets/images/hub-img2.webp",
        heading: "Security Provider",
        desc: "With enhanced security features, HopeLedger ensures the safety and integrity of your crowdfunding projects, offering additional rewards for staking.",
    },
    {
        imgUrl: "/assets/images/hub-img3.webp",
        heading: "Interchain Connector",
        desc: "Connecting various blockchains by establishing IBC connections, HopeLedger bridges the gap between platforms like Ethereum and Bitcoin.",
    },
    {
        imgUrl: "/assets/images/hub-img4.webp",
        heading: "Digital Asset Custodian",
        desc: "At the center of the blockchain ecosystem, HopeLedger securely manages digital assets and accounts across multiple chains.",
    },
];

const HubSection = () => {
    return (
        <div className='h-full w-[95%] py-20 lg:w-[65%] flex flex-col gap-16'>
            <div className='flex flex-col justify-center gap-5 py-20 bg-hubSection'>
                <div className='text-center'>
                    <StyledSmText fontColor="text-gray">ENTER THE HopeLedger HUB</StyledSmText>
                </div>
                <div className='text-center'>
                    <StyledH3Heading fontColor="text-gradient">The Heart of the CrowdFunding.</StyledH3Heading>
                </div>
                <div className='text-center'>
                    <StyledMdText fontColor="text-white">Serving as Pakistan's first decentralized crowdfunding platform, the HopeLedger Hub provides essential services to the blockchain ecosystem, ensuring transparency, security, and community-driven support.</StyledMdText>
                </div>
            </div>
            <div className='grid grid-cols-1 gap-16 lg:gap-32 lg:grid-cols-2'>
                {hubData.map((data, index) => (
                    <HubCard key={index} data={data} />
                ))}
            </div>
            <div className="lg:w-[24%]">
                <Button variant="button-gradient" fontColor="text-black">HopeLedger Hub</Button>
            </div>
        </div>
    )
}

export default HubSection
